"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.objectHasKeys = exports.objectHasKey = exports.isObject = exports.hasValue = void 0;
function hasValue(value) {
    return value !== null && value !== undefined;
}
exports.hasValue = hasValue;
function isObject(v) {
    return typeof v === 'object' && v !== null;
}
exports.isObject = isObject;
function objectHasKey(obj, key) {
    return key in obj;
}
exports.objectHasKey = objectHasKey;
function objectHasKeys(obj, keys) {
    return keys.every((key) => objectHasKey(obj, key));
}
exports.objectHasKeys = objectHasKeys;
//# sourceMappingURL=index.js.map